import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs'; 
@Component({
  selector: 'app-dailyroutedivert',
  template: require('./dailyroutedivert.component.html'),
  styles: []
})
export class DailyRouteDivertComponent implements OnInit {
  showMyContainer: boolean = false;
  private columnDefs;
  private rowData;
  private rowHeight;
  busy: Subscription;

  constructor() {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', width: 70 },
      { headerName: 'DCR Date', field: 'dcrdate', width: 100 },
      { headerName: 'Name', field: 'name', width: 250 },
      { headerName: 'HQ', field: 'hq', width: 250 },
      { headerName: 'TP Route', field: 'tproute', width: 300 },
      { headerName: 'Plane Route', field: 'planeroute', width: 250 },
      { headerName: 'Approved/Rejected By', field: 'remarks', width: 300 },
      { headerName: 'Status', field: 'status', width: 250 }
    ];

    this.rowData = [
      { sno: '1', dcrdate: "01/10/2021", name: "Bhagwan Sahai", hq: "Jaipur", tproute: "Ludhiana to Pindi St.", planeroute: "Ludhiana to Pindi St.", remarks: "Approved by Biplov", status: "Approved" },
      { sno: '2', dcrdate: "01/10/2021", name: "Bhagwan Sahai", hq: "Jaipur", tproute: "Ludhiana to Pindi St.", planeroute: "Ludhiana to Pindi St.", remarks: "Rejected by Biplov", status: "Rejected" },
      { sno: '3', dcrdate: "01/10/2021", name: "Bhagwan Sahai", hq: "Jaipur", tproute: "Ludhiana to Pindi St.", planeroute: "Ludhiana to Pindi St.", remarks: "Approved by Biplov", status: "Approved" },
    ];
    this.rowHeight = 50;
  }

  addTourGridEventHandler() {
    this.showMyContainer = true;
  }



  ngOnInit() {
  }

}
